module.exports = __webpack_public_path__ + "static/media/fruits_25.47453a7b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_25.csv
// module id = 690
// module chunks = 0